"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarContent = exports.StyledSidebarContent = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var Sidebar_1 = require("../Sidebar");
var innerFunction = function (_a) {
    var expanded = _a.expanded, margin = _a.margin, toggleSidebar = _a.toggleSidebar, rtl = _a.rtl, props = __rest(_a, ["expanded", "margin", "toggleSidebar", "rtl"]);
    return react_1.default.createElement("div", __assign({}, props));
};
exports.StyledSidebarContent = styled_components_1.default(innerFunction)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  margin-", ": ", "px;\n"], ["\n  background-color: ",
    ";\n  margin-", ": ",
    "px;\n"])), function (props) {
    return style_utils_1.getColor("gray", props.baseColor ? 0 : 10)(props);
}, function (props) { return (props.rtl ? "right" : "left"); }, function (props) {
    return style_utils_1.escapeCss(props.margin);
});
var SidebarContent = function (_a) {
    var className = _a.className, modelList = _a.modelList, sidebar = _a.sidebar, props = __rest(_a, ["className", "modelList", "sidebar"]);
    var _b = react_1.default.useContext(Sidebar_1.SidebarContext), expanded = _b.expanded, rtl = _b.rtl;
    var sidebarMargin = sidebar ? (expanded ? 257 : 50) : 0;
    var modelListMargin = modelList ? 360 : 0;
    return (react_1.default.createElement(exports.StyledSidebarContent, __assign({}, props, { className: style_utils_1.classNames("sidebar--content", className), margin: sidebarMargin + modelListMargin, rtl: rtl })));
};
exports.SidebarContent = SidebarContent;
exports.default = exports.SidebarContent;
var templateObject_1;
//# sourceMappingURL=index.js.map